import React, { useState } from 'react';
import UserForm from './UserForm';
import UserFeedBack from './UserFeedBack';
import styles from './UserReport.module.scss';
import { complaintList } from '../../lib/userReport';
import { CreateTicket, getDecsCities } from '../../api';
import { clickTracker } from '../../lib/common';
import { FaqWrapper } from '../common';
import { useAuth } from '../../contexts/auth';

function UserReport() {
  const [authState] = useAuth();
  const { userDetails } = authState;
  const [showUserform, setShowUserForm] = useState('');
  const [showFeedBack, setShowFeedBack] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [fileData, setFileData] = useState([]);
  const [fields, setFields] = useState({});
  const [createTicketResp, setCreateTicketResp] = useState('');
  const [haveSubmitted, setHaveSubmitted] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);

  const handleClick = async (item) => {
    const fieldsList = complaintList[item]?.fields || {};
    let cityList = {};
    setFileData([]);
    if (fieldsList) {
      Object.keys(fieldsList).forEach((element) => {
        if (fieldsList[element].name === 'userNumber') {
          fieldsList[element].fvalue = userDetails?.mobile;
        }
        if (fieldsList[element].name === 'userEmail') {
          fieldsList[element].fvalue = userDetails?.email;
        }
        if (fieldsList[element].name === 'city') {
          fieldsList[element].fvalue = userDetails?.city;
        }
        if (fieldsList[element].name === 'comment') {
          fieldsList[element].fvalue = '';
        }
        if (fieldsList[element].name === 'vendorName') {
          fieldsList[element].fvalue = '';
        }
        if (fieldsList[element].name === 'vendorNumber') {
          fieldsList[element].fvalue = '';
        }
        if (fieldsList[element].name === 'compname') {
          fieldsList[element].fvalue = '';
        }
      });
    }
    try {
      const cities = await getDecsCities(1);
      if (cities && Object.keys(cities).length > 0) {
        const citiesArr = Object.entries(cities);
        const sortedCities = Object.fromEntries(citiesArr.sort((a, b) => a[0].localeCompare(b[0])));
        cityList = Object.keys(sortedCities).length > 0 ? sortedCities : {};
        setSelectedItem({ selectedItem: item, cityList });
        setFields(fieldsList);
        setShowUserForm(true);
      }
    } catch (e) {
      console.log('Error: ', e);
    }
  };
  const handleSubmitClick = async () => {
    setHaveSubmitted(true);
    const document = [];
    fileData.forEach((item) => {
      document.push({
        nm: item.name,
        url: item.url,
      });
    });
    await clickTracker('issue_reportanissue_ticket', 'User_issue');
    const updatedComment = ['Profile related issue', 'Any other issue'].includes(selectedItem?.selectedItem)
      ? fields?.comment?.fvalue
      : `Company name: ${fields?.companyName?.fvalue || ''},\nCompany mobile: ${
          fields?.vendorNumber?.fvalue || ''
        },\nVendor name: ${fields?.vendorName?.fvalue || ''},\nDoc Id: ${fields?.docid?.fvalue || ''},\nDescription: ${
          fields?.comment?.fvalue || ''
        }`;
    const params = {
      vertical: 'USER EXPERIENCE',
      category: 'CS',
      ticket_creator: 'USER' || '',
      created_by: fields?.userNumber?.fvalue || '',
      compnm: '',
      company_mob: '',
      docid: '',
      mob: fields?.userNumber?.fvalue || '',
      nm: userDetails?.fullName || '',
      issue_type: complaintList[selectedItem.selectedItem]?.issue || '',
      issue_sub_type: complaintList[selectedItem.selectedItem]?.subIssue || '',
      issue_comment: updatedComment || '',
      document: document && document.length > 0 ? document : [],
      city: fields?.city?.fvalue || userDetails?.city,
      oid: complaintList[selectedItem.selectedItem]?.docid || '',
      src: 'USER' || '', // user changes
      src_typ: 'csportal' || '',
      src_nm: userDetails?.fullName || '',
      src_mob: fields?.userNumber?.fvalue || '',
      projectId: 1 || '',
      parentId: '',
      email_from: fields?.userEmail?.fvalue || '',
      source:
        queryParams?.get('raiseTicketTrackerID') === 'landing'
          ? 'getacallback_landing'
          : 'report an issue_button_csportal',
      tag: 'User newCS',
    };
    if (fields?.docid?.fvalue) {
      params.complaint_docid = [fields?.docid?.fvalue];
    }
    const res = await CreateTicket(params);
    setCreateTicketResp(res?.errorCode === 0 ? res?.result?.msg || '' : 'Error');
    setShowFeedBack(true);
    setHaveSubmitted(false);
  };

  return (
    <>
      <div className={`${styles.ComplaintsRadio} p-20`}>
        <div className="font16 fw600 color111">Please specify the type of complaint you wish to report.</div>

        <div className={`${styles.ComplaintsRadio__box} mt-5`}>
          {complaintList &&
            Object.keys(complaintList).map((item, key) => (
              <label htmlFor={`complain_list_${key}`} className={`${styles.ComplaintsRadio__Lable} mt-15`} key={key}>
                <input
                  aria-label="payment_redirection"
                  tabIndex={0}
                  role="button"
                  onKeyDown={() => {}}
                  onClick={() => handleClick(item)}
                  id={`complain_list_${key}`}
                  className={`${styles.ComplaintsRadio__Input}`}
                  type="radio"
                  name="ComplaintsRadio__Input"
                />
                <span className={`${styles.ComplaintsRadio__Icon} csicon`} />
                <span className={`${styles.ComplaintsRadio__Text} font14 fw500 color111 pl-10`}>{item}</span>
              </label>
            ))}
        </div>
      </div>
      {showUserform && (
        <UserForm
          selectedItem={selectedItem.selectedItem}
          cityList={selectedItem.cityList}
          fields={fields}
          setFields={setFields}
          fileData={fileData}
          setFileData={setFileData}
          handleSubmitClick={handleSubmitClick}
          haveSubmitted={haveSubmitted}
        />
      )}
      {showFeedBack && (
        <UserFeedBack
          showFeedBack={showFeedBack}
          setShowFeedBack={setShowFeedBack}
          createTicketResp={createTicketResp}
        />
      )}
    </>
  );
}

export default FaqWrapper(UserReport);
